import React from 'react';
import './WorldDbEmptyStart.css';

const IconFlame = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconPerson = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
    <path d="M19 8v6M22 11h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconInbox = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M22 12h-6l-2 3H10l-2-3H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconFlow = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="6" cy="6" r="2.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="18" cy="6" r="2.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="18" r="2.5" stroke="currentColor" strokeWidth="2" />
    <path d="M8.2 7.5l3 8M15.8 7.5l-3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const LeadsEmptyStart = ({
  onAddLead,
  onOpenInbox,
  onOpenFlows,
  canWrite = true,
}) => (
  <div className="wdEmpty wdEmpty--leads">
    <div className="wdEmpty-panel">
      <div className="wdEmpty-hero">
        <span className="wdEmpty-badge" aria-hidden="true">
          <IconFlame />
        </span>
        <p className="wdEmpty-eyebrow">Leadflow</p>
        <h2 className="wdEmpty-title wdEmpty-title--static">
          Save your best <span className="wdEmpty-swap">leads</span>
        </h2>
        <p className="wdEmpty-lead">
          Add a name from the inbox or by hand. Then flows and touchpoints can start.
        </p>
      </div>

      <div className="wdEmpty-grid">
        <button
          type="button"
          className="wdEmpty-card wdEmpty-card--primary"
          onClick={onAddLead}
          disabled={!canWrite}
        >
          <span className="wdEmpty-cardIcon wdEmpty-cardIcon--import">
            <IconPerson />
          </span>
          <span className="wdEmpty-cardBody">
            <span className="wdEmpty-cardTitle">Add a lead</span>
            <span className="wdEmpty-cardText">
              Create one by hand. Name and a way to reach them is enough to start.
            </span>
          </span>
          <span className="altBtn altBtn--save wdEmpty-cardBtn">Add lead</span>
        </button>

        <button
          type="button"
          className="wdEmpty-card"
          onClick={onOpenInbox}
        >
          <span className="wdEmpty-cardIcon wdEmpty-cardIcon--create">
            <IconInbox />
          </span>
          <span className="wdEmpty-cardBody">
            <span className="wdEmpty-cardTitle">From the inbox</span>
            <span className="wdEmpty-cardText">
              A warm reply becomes a lead in one click. Keep the thread and the person together.
            </span>
          </span>
          <span className="altBtn altBtn--petrol wdEmpty-cardBtn">Open inbox</span>
        </button>

        <button
          type="button"
          className="wdEmpty-card"
          onClick={onOpenFlows}
        >
          <span className="wdEmpty-cardIcon wdEmpty-cardIcon--api">
            <IconFlow />
          </span>
          <span className="wdEmpty-cardBody">
            <span className="wdEmpty-cardTitle">Retargeting flows</span>
            <span className="wdEmpty-cardText">
              Sequences and touchpoints wait in Settings. Ready once the first lead is in.
            </span>
          </span>
          <span className="altBtn altBtn--petrol wdEmpty-cardBtn">Open flows</span>
        </button>
      </div>

      {!canWrite && (
        <p className="wdEmpty-readonly">
          This workspace is read-only. Ask the owner to add the first lead.
        </p>
      )}
    </div>
  </div>
);

export default LeadsEmptyStart;
